<font style="font-weight:normal" *ngIf="playing()">{{eventResult.holes_played}}</font>
<font style="font-weight:normal" *ngIf="completed()">F</font>
<font style="font-weight:normal" *ngIf="notStarted()">N/S</font>